// extracted by mini-css-extract-plugin
module.exports = {"centerDiv":"search_centerDiv__2tmk4","searchBox":"search_searchBox__h30sG","loader-box":"search_loader-box__eMkrQ"};